import { SvgIcon, type SvgIconProps } from "@mui/material";
import GoogleG from "../../assets/brand/google-g-logo.svg?react";

/**
 * The official multicolour Google "G", as required by Google's sign-in
 * branding guidelines for a "Continue with Google" button. Do not recolour
 * or restyle it.
 */
export const GoogleLogo = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    component={GoogleG}
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-testid="google-logo"
  />
);
